const list = [
  { name: "권유담", type: "F", useYn: "N" },
  { name: "김광은", type: "M", useYn: "N" },
  { name: "김대원", type: "M", useYn: "N" },
  { name: "김예림", type: "F", useYn: "N" },
  { name: "김예송", type: "F", useYn: "N" },
  { name: "김여명", type: "M", useYn: "N" },
  { name: "김우경", type: "F", useYn: "N" },
  { name: "김유석", type: "M", useYn: "N" },
  { name: "김지원", type: "M", useYn: "N" },
  { name: "김지주", type: "M", useYn: "N" },
  { name: "김찬우", type: "M", useYn: "N" },
  { name: "김태훈", type: "M", useYn: "N" },
  { name: "박도희", type: "F", useYn: "N" },
  { name: "박병호", type: "M", useYn: "Y" },
  { name: "박예빈", type: "F", useYn: "N" },
  { name: "박윤걸", type: "M", useYn: "N" },
  { name: "박윤지", type: "F", useYn: "N" },
  { name: "박인서", type: "M", useYn: "N" },
  { name: "백민서", type: "M", useYn: "N" },
  { name: "백민우", type: "M", useYn: "N" },
  { name: "백하영", type: "F", useYn: "N" },
  { name: "서봉규", type: "M", useYn: "N" },
  { name: "신기락", type: "M", useYn: "N" },
  { name: "신성호", type: "M", useYn: "N" },
  { name: "신예은", type: "F", useYn: "N" },
  { name: "신지원", type: "F", useYn: "N" },
  { name: "안예현", type: "M", useYn: "N" },
  { name: "오송현", type: "F", useYn: "N" },
  { name: "유　리", type: "F", useYn: "N" },
  { name: "이명철", type: "M", useYn: "N" },
  { name: "이민수", type: "M", useYn: "N" },
  { name: "이신우", type: "F", useYn: "N" },
  { name: "이연우", type: "F", useYn: "N" },
  { name: "이유나", type: "F", useYn: "N" },
  { name: "이지우", type: "M", useYn: "N" },
  { name: "이찬미", type: "F", useYn: "N" },
  { name: "장진영", type: "M", useYn: "N" },
  { name: "전솔담", type: "M", useYn: "N" },
  { name: "정다훈", type: "M", useYn: "N" },
  { name: "주예지", type: "F", useYn: "N" },
  { name: "차영광", type: "M", useYn: "N" },
  { name: "최소민", type: "F", useYn: "N" },
  { name: "최우석", type: "M", useYn: "N" },
  { name: "한예지", type: "F", useYn: "N" },
  { name: "황유빈", type: "F", useYn: "N" },
  { name: "목사님", type: "N", useYn: "N" },
  { name: "부장님", type: "N", useYn: "N" }
];
export default list;
